(function () {
	const header = () => {
		const header = document.querySelector('.c-header');
		const headerLogo = document.querySelector('.c-header__link');
		const headerBtnBox = document.querySelectorAll('.c-header__btn-box');
		const headerSearch = document.querySelector('.c-header__icon-btn--search');
		const headerSearchDim = document.querySelector('.c-header__dim');

		let prvScrollY = 0;
		const setFoldHeight = (parent, set) => {
			const fold = parent.querySelector('.c-header__fold');
			const foldBody = fold.querySelector('.c-header__body');
			const searchBox = headerSearch.closest('.c-header__icon-box');

			if(searchBox.classList.contains('c-header__icon-box--active')) {
				searchBox.classList.remove('c-header__icon-box--active');
				scrollSet.otherLenisScroll('.c-header__search-wrap', false);
			}
			if(set === 0) {
				parent.classList.remove('c-header__btn-box--active');
				fold.style.maxHeight = 0 + "px";
				fold.style.height = 0 + "px";
			} else {
				parent.classList.add('c-header__btn-box--active');
				fold.style.maxHeight = foldBody.scrollHeight + 80 + "px";
				fold.style.height = foldBody.scrollHeight + 80 + "px";
			}
		}
		const headerActive = (active) => {
			if(active == 'active') {
				header.classList.add('c-header--active');
			} else {
				header.classList.remove('c-header--active');
			}
		}
		headerBtnBox.forEach(box => {
			box.addEventListener('mouseover', () => setFoldHeight(box, 1));
			box.addEventListener('mouseout', () => setFoldHeight(box, 0));
			box.addEventListener('focusin', () => setFoldHeight(box, 1));
			box.addEventListener('focusout', () => setFoldHeight(box, 0));
		})
		headerLogo.addEventListener('focusin', () => headerActive('active'));

		// scroll 
		window.addEventListener('scroll', () => {
			let currentScrollY = window.scrollY;
			// 50px 이상 스크롤시
			if(window.scrollY > 50) {
				header.classList.add('c-header--active');
			} else {
				header.classList.remove('c-header--active');
				header.classList.remove('c-header--down');
			}
			
			// 스크롤 올릴때
			if(window.scrollY > 50) {
				if(window.scrollY < prvScrollY) {
					header.classList.remove('c-header--down');
				} else {
					header.classList.add('c-header--down');
				}
			}
			prvScrollY = currentScrollY;
		})
		headerSearch.addEventListener('click', () => {
			const iconBox = headerSearch.closest('.c-header__icon-box');
			if(iconBox.classList.contains('c-header__icon-box--active')) {
				iconBox.classList.remove('c-header__icon-box--active');
				scrollSet.otherLenisScroll('.c-header__search-wrap', false);
			} else {
				iconBox.classList.add('c-header__icon-box--active');
				scrollSet.otherLenisScroll('.c-header__search-wrap', true);
			}
			
		})
		headerSearchDim.addEventListener('click', () => {
			const iconBox = headerSearch.closest('.c-header__icon-box');
			if(iconBox.classList.contains('c-header__icon-box--active')) {
				iconBox.classList.remove('c-header__icon-box--active');
				scrollSet.otherLenisScroll('.c-header__search-wrap', false);
			} 
		})
		const cSearch = document.querySelectorAll('.c-search > input');
		const cSearchDelete = document.querySelectorAll('.c-search__delete');
		if(cSearch) {
			cSearch.forEach(input => {
				const searchBox = input.closest('.c-search');
				input.addEventListener('input', () => {
					if(input.value.length > 0) {
						searchBox.classList.add('c-search--active');
					} else {
						searchBox.classList.remove('c-search--active');
					}
				})
			})
			cSearchDelete.forEach(del => {
				const searchBox = del.closest('.c-search');
				const searchInput = searchBox.querySelector('.c-search > input');
				del.addEventListener('click', () => {
					searchInput.value = ""
					searchBox.classList.remove('c-search--active');
				})
			})
		}
		const mypageBtn = document.querySelector('.c-header__icon-btn--mypage');
		const headerDropBox = mypageBtn.closest('.c-header__drop-box');
		if(mypageBtn) {
			mypageBtn.addEventListener('click', () => {
				headerDropBox.classList.toggle('c-header__drop-box--active');
			})
		}
		document.addEventListener('click', (e) => {
			if(headerDropBox.classList.contains('c-header__drop-box--active') && !headerDropBox.contains(e.target)) {
				headerDropBox.classList.remove('c-header__drop-box--active');
			}
		})

		const headerCart = document.querySelector('.c-header__icon-btn--cart');
		if(!headerCart) return;
		const headerDrawer = document.querySelector('.drawer');
		if(!headerDrawer) return;

		headerCart.addEventListener('click', () => {
			if(headerDrawer.classList.contains('active')) {
				scrollSet.otherLenisScroll('.drawer', false);
			} else {
				scrollSet.otherLenisScroll('.drawer', true);
			}
		})
		if(headerDrawer.classList.contains('active')) {
			console.log('111')
			scrollSet.otherLenisScroll('.drawer', false);
		} else {
			scrollSet.otherLenisScroll('.drawer', true);
		}
	}

	document.addEventListener('shopify:section:load', header);
	header();
})();
